export default "__VITE_ASSET__1aa37146__"